// extracted by mini-css-extract-plugin
export var menuIcon = "_re-0";
export var menuIconInline = "_re-1";